module.exports = __webpack_public_path__ + "img/Calendar-30day.d187e47c.svg";